/* TETO – pagina prodotto mobile: barra acquisto fissa + galleria verticale filtrata per variante.
   Attivo solo sotto i 1000px. Desktop invariato. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 999px)');
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim()
      .replace(/\s+/g, '-');
  }

  /* ---------------------------------------------------------------- barra */
  // La barra e' una COPIA dei blocchi della scheda (titolo, prezzo, varianti, aggiungi al carrello).
  // La scheda originale resta al suo posto sotto le foto; la barra compare solo quando la scheda non e' visibile
  // (mentre si scorrono le foto e dopo, nelle descrizioni). Ogni interazione sulla copia viene girata all'originale.

  var BAR_BLOCKS = [
    { sel: '.product-info__block-item[data-block-type="title"]', zone: 'head' },
    { sel: '.product-info__block-item[data-block-type="price"]', zone: 'head' },
    { sel: '.product-info__block-item[data-block-type="variant-picker"]', zone: 'options' },
    { sel: '.product-info__block-item[data-block-type="buy-buttons"]', zone: 'buy' }
  ];

  function cleanClone(block) {
    var clone = block.cloneNode(true);
    clone.setAttribute('data-block-id', 'teto-copy-' + (block.getAttribute('data-block-id') || ''));
    clone.removeAttribute('data-shopify-editor-block');
    // niente id duplicati, niente campi associati al form vero (altrimenti verrebbero inviati due volte)
    clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    clone.querySelectorAll('label[for]').forEach(function (el) { el.removeAttribute('for'); });
    clone.querySelectorAll('input, select, textarea, button').forEach(function (el) {
      el.removeAttribute('form');
      el.removeAttribute('name');
      if (el.tagName === 'BUTTON' && el.type === 'submit') el.type = 'button';
    });
    clone.querySelectorAll('script, style, form, product-form, payment-terms, .teto-delivery, .shopify-payment-button').forEach(function (el) {
      if (el.tagName === 'FORM' || el.tagName === 'PRODUCT-FORM') {
        // teniamo solo i bottoni, senza il form
        var buy = el.querySelector('buy-buttons');
        if (buy) el.replaceWith(buy);
        else el.remove();
      } else {
        el.remove();
      }
    });
    // gli elementi custom del tema (variant-picker, quantity-selector...) non devono attivarsi sulla copia:
    // li sostituiamo con <div> mantenendo classi e attributi, cosi' restano solo grafica
    ['variant-picker', 'quantity-selector', 'quantity-input', 'buy-buttons', 'product-rerender'].forEach(function (tag) {
      clone.querySelectorAll(tag).forEach(function (el) {
        var div = document.createElement('div');
        Array.prototype.forEach.call(el.attributes, function (a) { div.setAttribute(a.name, a.value); });
        div.classList.add(tag);
        while (el.firstChild) div.appendChild(el.firstChild);
        el.replaceWith(div);
      });
    });
    return clone;
  }

  function buildBar(bar) {
    var root = bar.closest('product-rerender') || document;
    var info = root.querySelector('.product-info');
    if (!info) return;
    bar.__info = info;

    var inner = document.createElement('div');
    inner.className = 'teto-mobile-bar__inner';
    var zones = {};
    ['head', 'options', 'buy'].forEach(function (name) {
      zones[name] = document.createElement('div');
      zones[name].className = 'teto-mobile-bar__' + name;
      inner.appendChild(zones[name]);
    });

    BAR_BLOCKS.forEach(function (def) {
      info.querySelectorAll(def.sel).forEach(function (block) {
        if (!block.children.length) return;
        var clone = cleanClone(block);
        clone.__source = block;
        zones[def.zone].appendChild(clone);
      });
    });

    var old = bar.querySelector('.teto-mobile-bar__inner');
    if (old) old.replaceWith(inner); else bar.appendChild(inner);
    bar.__built = true;
    updateBodyPadding(bar);
  }

  // click sulla copia -> stessa azione sull'originale
  function onBarClick(event) {
    var bar = event.currentTarget;
    var info = bar.__info;
    if (!info) return;

    // 1) opzione variante (label/swatch/blocco) -> input originale con lo stesso valore
    var label = event.target.closest('.teto-mobile-bar__options label');
    if (label) {
      event.preventDefault();
      var input = label.previousElementSibling;
      if (input && input.tagName === 'INPUT') {
        var picker = label.closest('.product-info__block-item');
        var srcPicker = picker && picker.__source;
        var original = srcPicker && Array.prototype.find.call(srcPicker.querySelectorAll('input[type="radio"]'), function (el) {
          return el.value === input.value && el.getAttribute('data-option-position') === input.getAttribute('data-option-position');
        });
        if (original && !original.checked) {
          original.checked = true;
          original.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      return;
    }

    // 2) aggiungi al carrello -> submit del bottone originale
    var buyBtn = event.target.closest('.teto-mobile-bar__buy .buy-buttons button');
    if (buyBtn) {
      event.preventDefault();
      var buyBlock = buyBtn.closest('.product-info__block-item');
      var srcBuy = buyBlock && buyBlock.__source;
      var srcBtn = srcBuy && srcBuy.querySelector('.buy-buttons button[type="submit"]');
      if (srcBtn && !srcBtn.disabled) srcBtn.click();
      return;
    }
  }

  function setupBar(bar) {
    if (!bar.__built) {
      buildBar(bar);
      bar.addEventListener('click', onBarClick);
      watchInfo(bar);
    }
  }

  function rebuildBar(bar) {
    if (!MQ.matches) return;
    buildBar(bar);
  }

  // la barra e' visibile solo quando la scheda originale (titolo/prezzo/varianti/carrello) NON e' nello schermo
  function watchInfo(bar) {
    var info = bar.__info;
    if (!info || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var infoVisible = entry.isIntersecting;
      bar.classList.toggle('is-visible', MQ.matches && !infoVisible);
      updateBodyPadding(bar);
    }, { threshold: 0 });
    observer.observe(info);
  }

  function restoreBar(bar) {
    bar.classList.remove('is-visible');
    document.body.style.removeProperty('padding-bottom');
    document.documentElement.style.removeProperty('--teto-bar-h');
  }

  function updateBodyPadding(bar) {
    if (!MQ.matches || !bar.classList.contains('is-visible')) {
      document.body.style.removeProperty('padding-bottom');
      document.documentElement.style.removeProperty('--teto-bar-h');
      return;
    }
    var h = bar.offsetHeight;
    document.body.style.paddingBottom = h + 'px';
    document.documentElement.style.setProperty('--teto-bar-h', h + 'px');
  }

  /* ------------------------------------------------------------- galleria */

  // Set di immagini della variante corrente secondo l'app StarApps "Variant Image Automator" (se ancora presente):
  // l'app riscrive il carosello del tema (nascosto su mobile) lasciando solo le foto della variante e aggiorna window.variant_images.
  function appMediaIds() {
    var ids = [];
    if (Array.isArray(window.variant_images) && window.variant_images.length) {
      ids = window.variant_images.map(function (m) { return String(m.id); });
    } else {
      var gallery = document.querySelector('.shopify-section--main-product product-gallery');
      if (gallery && gallery.classList.contains('starapps')) {
        ids = Array.prototype.map.call(gallery.querySelectorAll('.product-gallery__media:not([hidden])[data-media-id]'), function (el) {
          return el.getAttribute('data-media-id');
        });
      }
    }
    return ids;
  }

  function applyVisibility(gallery, visible, key, options) {
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.teto-mobile-gallery__item'));
    var total = visible.length;
    var n = 0;

    // la pagina non deve "saltare": se l'utente e' sotto la galleria (scheda, descrizioni...) e il numero di foto
    // cambia, compensiamo lo scroll di quanto si e' spostata la scheda, cosi' resta alla stessa altezza
    var anchor = gallery.parentNode ? gallery.parentNode.querySelector('.product-info') : null;
    var anchorTop = anchor ? anchor.getBoundingClientRect().top : null;

    // numerazione: prima le foto della variante, poi quelle comuni (che stanno in fondo)
    var ordered = visible.filter(function (i) { return i.getAttribute('data-group') !== 'g'; })
      .concat(visible.filter(function (i) { return i.getAttribute('data-group') === 'g'; }));

    items.forEach(function (item) {
      var show = visible.indexOf(item) !== -1;
      item.hidden = !show;
      var counter = item.querySelector('.teto-mobile-gallery__counter');
      if (counter && !show) counter.textContent = '';
    });
    ordered.forEach(function (item) {
      var counter = item.querySelector('.teto-mobile-gallery__counter');
      n += 1;
      if (counter) counter.textContent = n + ' / ' + total;
      var img = item.querySelector('img[loading="lazy"]');
      if (img && n <= 2) img.loading = 'eager';
    });

    var changed = key !== (gallery.getAttribute('data-current-key') || '');
    gallery.setAttribute('data-current-key', key);

    if (changed && anchor && anchorTop !== null && anchorTop < window.innerHeight) {
      var delta = anchor.getBoundingClientRect().top - anchorTop;
      if (delta) window.scrollBy(0, delta);
    }
    return changed;
  }

  // Ordine di priorita':
  // 1) gruppi calcolati in Liquid (data-group = immagine principale che apre il gruppo, "g" = comuni) + immagine
  //    principale della variante selezionata -> stessa regola di StarApps, ma senza script esterni;
  // 2) set di immagini dell'app StarApps se ancora attiva; 3) nome colore nell'alt / nome file; 4) tutte.
  function filterGallery(gallery, state, options) {
    options = options || {};
    state = state || {};
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.teto-mobile-gallery__item'));
    if (!items.length) return;

    var visible = [];
    var key = '';
    var hasGroups = items.some(function (i) { return i.hasAttribute('data-group'); });

    if (hasGroups && state.featuredId) {
      var fid = String(state.featuredId);
      var own = items.filter(function (i) { return i.getAttribute('data-group') === fid; });
      if (own.length) {
        visible = own.concat(items.filter(function (i) { return i.getAttribute('data-group') === 'g'; }));
        key = 'group:' + fid;
      }
    }

    if (!visible.length) {
      var ids = appMediaIds();
      if (ids.length) {
        visible = items.filter(function (item) { return ids.indexOf(item.getAttribute('data-media-id')) !== -1; });
        key = 'ids:' + ids.join(',');
      }
    }

    if (!visible.length) {
      key = normalize(state.color);
      visible = key
        ? items.filter(function (item) { return (item.getAttribute('data-key') || '').indexOf(key) !== -1; })
        : [];
    }

    if (!visible.length) {
      visible = items;
      key = 'all';
    }

    applyVisibility(gallery, visible, key, options);
  }

  var lastState = {};

  function refilterAll(options) {
    document.querySelectorAll('.teto-mobile-gallery').forEach(function (gallery) {
      filterGallery(gallery, lastState, options);
    });
  }

  function onVariantChange(event) {
    if (!MQ.matches) return;
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant) return;

    document.querySelectorAll('.teto-mobile-gallery').forEach(function (gallery) {
      // nota: nel tema detail.formId può essere l'input "id" del form (form.id è oscurato), quindi confrontiamo solo se è una stringa
      var formId = typeof detail.formId === 'string' ? detail.formId : (detail.formId && detail.formId.form ? detail.formId.form.getAttribute('id') : null);
      if (formId && gallery.getAttribute('data-form-id') && gallery.getAttribute('data-form-id') !== formId) return;
      var index = parseInt(gallery.getAttribute('data-color-option-index'), 10) || 1;
      var color = variant['option' + index];
      if (color == null && variant.options) color = variant.options[index - 1];
      var featuredId = variant.featured_media ? variant.featured_media.id : (variant.featured_image ? variant.featured_image.id : null);
      lastState = { featuredId: featuredId, color: color };
      filterGallery(gallery, lastState, {});
    });

    // se l'app StarApps e' ancora attiva aggiorna il suo set in modo asincrono: riproviamo per qualche istante
    [150, 400, 900, 1800].forEach(function (ms) {
      setTimeout(function () { refilterAll({}); }, ms);
    });
  }

  // osserviamo il carosello del tema: quando l'app lo riscrive, allineiamo la galleria mobile
  function watchThemeGallery() {
    var gallery = document.querySelector('.shopify-section--main-product product-gallery');
    if (!gallery || gallery.__tetoWatched || !('MutationObserver' in window)) return;
    gallery.__tetoWatched = true;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { if (MQ.matches) refilterAll({}); }, 80);
    }).observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  /* ----------------------------------------------------------------- init */

  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function () {
        document.querySelectorAll('.teto-mobile-bar').forEach(updateBodyPadding);
      })
    : null;

  function init() {
    document.querySelectorAll('.teto-mobile-bar').forEach(function (bar) {
      if (MQ.matches) setupBar(bar);
      else restoreBar(bar);
      if (ro) ro.observe(bar);
    });
    watchThemeGallery();
    if (MQ.matches) {
      var g = document.querySelector('.teto-mobile-gallery');
      if (g && !lastState.featuredId) {
        var sel = g.getAttribute('data-selected-group');
        if (sel && sel !== 'all') lastState = { featuredId: sel };
      }
      refilterAll({});
      [300, 1000, 2500].forEach(function (ms) { setTimeout(function () { refilterAll({}); }, ms); });
    }
  }

  document.addEventListener('variant:change', function (event) {
    onVariantChange(event);
    // il tema ha appena ri-renderizzato i blocchi originali: rifacciamo la copia nella barra
    document.querySelectorAll('.teto-mobile-bar').forEach(rebuildBar);
    setTimeout(function () { document.querySelectorAll('.teto-mobile-bar').forEach(rebuildBar); }, 400);
  });

  if (MQ.addEventListener) MQ.addEventListener('change', init);
  else MQ.addListener(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // l'editor del tema ricarica le sezioni
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 60); });
})();
